'use client';

import Script from 'next/script';

import { isProduction } from '@/helpers/common';

export const HotjarScript = () => {
  if (!isProduction()) {
    return null;
  }

  return <Script src="/pixels/hotjar.js" strategy="afterInteractive" />;
};
